import {ReportByDay} from "../models/Report";
import {Product, ProductCategory} from "../models/Product";
import {DailyReportTemplateData} from "./DailyReportTemplateData";
import {DailyReportImportTemplate} from "./DailyReportImportTemplate";
import {cloneDeep} from "lodash";

export const getDailyReportTemplate = (
    data: ReportByDay[],
    selectedProduct: Product,
    selectedProductCategory: ProductCategory,
    totalInputNeto: number,
    totalInputSrps: number,
    totalOutputNeto: number,
    totalOutputSrps: number
    ) => {
    return DailyReportImportTemplate(prepareData(
        data,
        selectedProduct,
        selectedProductCategory,
        totalInputNeto,
        totalInputSrps,
        totalOutputNeto,
        totalOutputSrps
    ));
};

const prepareData = (
    documentData: ReportByDay[],
    selectedProduct: Product,
    selectedProductCategory: ProductCategory,
    totalInputNeto: number,
    totalInputSrps: number,
    totalOutputNeto: number,
    totalOutputSrps: number
    ) => {
    const templateData: DailyReportTemplateData = {
        productName: selectedProduct.name ?? selectedProductCategory.name ?? 'Svi proizvodi',
        reportByDay: cloneDeep(documentData),
        totalInputNeto: totalInputNeto,
        totalInputSrps: totalInputSrps,
        totalOutputNeto: totalOutputNeto,
        totalOutputSrps: totalOutputSrps
    };

    return templateData;
};